import React from "react";
import PropTypes from "prop-types";

import { UIIcon } from "../../../../ui";
import Card from "../../../../Card";
import TimelineGroup from "../../TimelineGroup";
import { clx } from "../../../../../utils/Helpers";

const EventTimelineSection = ({
  labels,
  hasError,
  showBuildUpAndDismantling,
  timelineFieldsDisabled,
}) => (
  <Card
    title={labels.eventTimeline}
    classNames={{
      root: clx("basic-info-timeline", { "form-section--error": hasError }),
    }}
  >
    <div className="basic-info-timeline__groups">
      {showBuildUpAndDismantling && (
        <TimelineGroup
          title={labels.buildUp}
          icon={
            <UIIcon
              name="buildUp"
              size="sm"
              color="var(--color-foreground-muted)"
            />
          }
          startName="building_start_at"
          endName="building_end_at"
          labels={labels}
          disabled={timelineFieldsDisabled}
        />
      )}
      <TimelineGroup
        title={labels.actualEvent}
        icon={
          <UIIcon
            name="checkCalendar"
            size="sm"
            color="var(--color-foreground-muted)"
          />
        }
        startName="event_start_at"
        endName="event_end_at"
        labels={labels}
        required
        classNames={{
          root: "actual-event-label",
        }}
        disabled={timelineFieldsDisabled}
      />
      {showBuildUpAndDismantling && (
        <TimelineGroup
          title={labels.dismantling}
          icon={
            <UIIcon
              name="car"
              size="sm"
              color="var(--color-foreground-muted)"
            />
          }
          startName="dismantling_start_at"
          endName="dismantling_end_at"
          labels={labels}
          disabled={timelineFieldsDisabled}
        />
      )}
    </div>
  </Card>
);

EventTimelineSection.propTypes = {
  labels: PropTypes.object.isRequired,
  hasError: PropTypes.bool,
  showBuildUpAndDismantling: PropTypes.bool,
  timelineFieldsDisabled: PropTypes.bool,
};

EventTimelineSection.defaultProps = {
  hasError: false,
  showBuildUpAndDismantling: true,
  timelineFieldsDisabled: false,
};

export default EventTimelineSection;
